var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMenuIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 23.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0610_\u5F8C\u53F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.86,4.26,13.74.14A.47.47,0,0,0,13.41,0H.46A.47.47,0,0,0,0,.46V9.79a.47.47,0,0,0,.93,0V.93h12V4.59a.47.47,0,0,0,.47.47h3.66V22.82H.93V14A.47.47,0,0,0,0,14v9.33a.47.47,0,0,0,.46.46H17.54a.47.47,0,0,0,.46-.46V4.59A.47.47,0,0,0,17.86,4.26Zm-4-2.68,2.55,2.55H13.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92,20.23H3.07c-.46,0-.84.2-.84.46s.38.46.84.46H14.92c.46,0,.84-.2.84-.46S15.38,20.23,14.92,20.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92,17.63H3.16c-.46,0-.84.21-.84.46s.38.47.84.47H14.92c.46,0,.84-.21.84-.47S15.38,17.63,14.92,17.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92,15.22H3.07c-.46,0-.84.2-.84.46s.38.46.84.46H14.92c.46,0,.84-.2.84-.46S15.38,15.22,14.92,15.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92,12.62H3.16c-.46,0-.84.21-.84.46s.38.47.84.47H14.92c.46,0,.84-.21.84-.47S15.38,12.62,14.92,12.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92,10H3.16c-.46,0-.84.21-.84.46s.38.47.84.47H14.92c.46,0,.84-.21.84-.47S15.38,10,14.92,10Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9,2.6H2.7a.47.47,0,1,0,0,.93H9A.47.47,0,0,0,9,2.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,6.12H5.5a.46.46,0,0,0,0-.92H2.7a.46.46,0,1,0,0,.92Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9,6.12A.46.46,0,1,0,9,5.2H8.09a.46.46,0,0,0,0,.92Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M.46,12.34a.44.44,0,0,0,.33-.14.43.43,0,0,0,.14-.32.44.44,0,0,0-.14-.33.44.44,0,0,0-.33-.14.43.43,0,0,0-.32.14.44.44,0,0,0-.14.33.43.43,0,0,0,.14.32A.43.43,0,0,0,.46,12.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIcon5);
export default __webpack_public_path__ + "static/media/homeMenuIcon5.31c9e133fb86e87ceb00b67e342f4e52.svg";
export { ForwardRef as ReactComponent };